import { render, staticRenderFns } from "./LoyaltyRewards.vue?vue&type=template&id=717082ed&scoped=true&"
import script from "./LoyaltyRewards.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyRewards.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyRewards.vue?vue&type=style&index=0&id=717082ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717082ed",
  null
  
)

export default component.exports